import { useTranslation } from "react-i18next";
import helpers from "../../../Utils/helpers";
import { FormInput } from "../../FormComponents/Input/Input";

export default function CompensationTicketInfo({ ticket }) {
    const { t } = useTranslation();

    return (
        <form className={`form-horizontal col-6`}>
            <fieldset className="d-grid col-12 gap-16 mb-16">
                <FormInput label={t("settingscompensationeditcontainer.customernumber")} value={ticket.customerNumber} readOnly />
                <FormInput label={t("settingscompensationeditcontainer.created")} value={helpers.formatDateAndTime(ticket.created)} readOnly />
                <FormInput label={t("settingscompensationeditcontainer.productname")} value={ticket.productName} readOnly />
                <FormInput label={t("settingscompensationeditcontainer.product")} value={ticket.product} readOnly />
                <FormInput label={t("settingscompensationeditcontainer.compensationreason")} value={ticket.reasonName} readOnly />
            </fieldset>
        </form>)
}